export const PORTAL_BASE_PATH = '/portal'
